import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { BaseCrudService } from 'projects/ProjetoBaseAngular/domain/services/base-crud.service';
import { EquipamentoModel } from '../models';

@Injectable({
  providedIn: 'root'
})
export class EquipamentoService extends BaseCrudService<EquipamentoModel> {

  constructor(injector: Injector) {
    super(injector);
  }

  public getController(): string {
    return 'Equipamento';
  }

  getAll(): Observable<EquipamentoModel[]> {
    return this
      .httpClient
      .get(`${this.getApiUrl()}${this.getController()}`, this.getAuthHeaderJson())
      .pipe(
        map(this.extractData),
        catchError(this.serviceError)
      );
  }
}
